import tokens from '../../../packages/brand/tokens.json'

/** Brand colours as CSS custom properties, straight from packages/brand/tokens.json (ADR-0011). */
export function applyBrandTokens(root: HTMLElement = document.documentElement): void {
  for (const [name, value] of Object.entries(tokens.color)) {
    if (typeof value === 'string') root.style.setProperty(`--${kebab(name)}`, value)
  }
  // The type scale: --fs-xs .. --fs-money in px (web column), plus --fs-hero for the sign-in and legal headings.
  for (const [name, size] of Object.entries(tokens.type.scale)) root.style.setProperty(`--fs-${name}`, `${size.web}px`)
  for (const [name, value] of Object.entries(tokens.type.webOnly)) root.style.setProperty(`--fs-${name}`, value)
}

function kebab(s: string): string {
  return s.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`)
}
